import { render, staticRenderFns } from "./navbar-x.vue?vue&type=template&id=1607ca5b&scoped=true"
import script from "./navbar-x.vue?vue&type=script&lang=js"
export * from "./navbar-x.vue?vue&type=script&lang=js"
import style0 from "./navbar-x.vue?vue&type=style&index=0&id=1607ca5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1607ca5b",
  null
  
)

export default component.exports